import React, { ReactElement } from 'react'
import Divider from '../Divider'
import AirdropOverview from './AirdropOverview'

const AirdropPanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <AirdropOverview />
        </div>
    )
}

export default AirdropPanel
